import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import DashboardContext from "../../../../contexts/DashboardContext";
import Loading from "../../../../components/Shared/ResourceIndex/Loading";
import AppContext from '../../../../contexts/AppContext';
import userApi from '../../../../utils/api/user';
import TenantFeatureContext  from '../../../../contexts/TenantContext';
import { useTenantRedirect } from '../../../../hooks/useTenantRedirect';
import MFAVerificationModal from '../../../Shared/MFAVerificationModal';

const ProjectList = ({selectedProjects,setSelectedProjects}) => {
  const [clientIsAscending, setClientIsAscending] = useState(true)
  const [siteIsAscending, setSiteIsAscending] = useState(true)  
  const appContext = useContext(AppContext);
   
  const {
    redirectToTenant,
    showMFAModal,
    mfaData,
    handleMFAVerificationSuccess,
    handleMFAModalClose,
    authStore,
  } = useTenantRedirect();
 
  const user = appContext.get('user');
  const { displayStatsForMP, isLoadingForMP, setDisplayStatsForMP } = useContext(DashboardContext)
  const tenantFeatureContext = useContext(TenantFeatureContext);


  //SORT
  const sortBySiteName = () => {
    const updatedList = displayStatsForMP.sort((a, b) => {
      let A = a.project.name.toString().toLowerCase()

      let B = b.project.name.toString().toLowerCase()

      if (siteIsAscending === true) {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setSiteIsAscending(!siteIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForMP(updatedList)
  }
  
  const sortByClientName = () => {
    const updatedList = displayStatsForMP.sort((a, b) => {
      let A = a.project.client.name.toString().toLowerCase()

      let B = b.project.client.name.toString().toLowerCase()

      if (clientIsAscending === true) {
        setClientIsAscending(!clientIsAscending)

        return A > B ? -1 : 1 // descending
      }

      else {
        setClientIsAscending(!clientIsAscending)

        return A > B ? 1 : -1 //ascending
      }
    })

    setDisplayStatsForMP(updatedList)
  }


  const handleRedirect = (ele) => {
    const redirectPath = `/divisions/${ele.division.id}/projects/${ele.project_id}/inspections`;
    redirectToTenant(ele.division.tenant_id, redirectPath);
  };

  const handleCheckboxChange = (project) => {
    setSelectedProjects(prevSelectedProjects =>
      prevSelectedProjects.includes(project)
        ? prevSelectedProjects.filter(selectiedProject => selectiedProject.id !== project.id)
        : [...prevSelectedProjects, project]
    );
  };

  
  return (
    <>
      <div className="projects-list">
        <div className="projects-list__content">
          <div className="projects-list__table-head">
            <h3 onClick={sortBySiteName}>Site Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
            <h3 onClick={sortByClientName}>Client Name <span><FontAwesomeIcon icon={faSort} /></span></h3>
            <h3>Action</h3>
          </div>

          {!isLoadingForMP ?
            (displayStatsForMP && displayStatsForMP.map((ele, index) => {

              return (
                <div key={index} className="projects-list__table-body">
                {tenantFeatureContext.tenantHasFeature('Enable Route Planner') ?
                  <input
                    type="checkbox"
                    checked={selectedProjects.find(selectedProject=>selectedProject.id === ele.project_id)}
                    onChange={() => handleCheckboxChange(ele.project)}
                    disabled={
                      (selectedProjects.length ===10 && !selectedProjects.find(selectedProject=>selectedProject.id === ele.project_id))
                    }
                  />:<text></text>
                  }
                  <li> 
                  {ele.project.name}</li>
                  <li>{ele.project.client.name}</li>

                  {ele.division && ele.division.tenant_id === user.tenantId ? (
                    <li>
                      <Link
                        to={`/divisions/${ele.division.id}/projects/${ele.project_id}/inspections`}
                      >
                        <span>View Project</span>
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <span onClick={() => handleRedirect(ele)}>View Project</span>
                    </li>
                  )}
                </div>
              );
            })
          ) : (
            <Loading what='data' />
          )}
        </div>
      </div>

      {mfaData && (
        <MFAVerificationModal
          show={showMFAModal}
          handleClose={handleMFAModalClose}
          onVerificationSuccess={handleMFAVerificationSuccess}
          email={mfaData.email}
          sendVerificationCode={authStore.sendVerificationCode}
          verifyCode={authStore.verifyCode}
        />
      )}
    </>
  );
};

export default ProjectList;
